import axios from "axios";

import ConnUrls from '../Connections/ConnectURL'


const orderMyFood = async (obj) => {
    try {
        let dFromF = await axios.post(ConnUrls.ApiUrl + "order/nOrder", obj);
        return (dFromF.data);
    } catch (err) {
        // nOrder מחזיר 400 עם { errMsg, orderBlocked } כשההזמנה נדחתה (מחוץ
        // לשעות / אמצעי תשלום לא מותר / לקוח חסום-טוקן מול עסק J5). מחזירים
        // את גוף השגיאה כדי ש-TheOrderList יציג פופאפ במקום ליפול בשקט.
        if (err && err.response && err.response.data && err.response.data.orderBlocked) {
            return err.response.data;
        }
        throw err;
    }
}

const tempoOrder = async (obj) => {
    let dFromF = await axios.post(ConnUrls.ApiUrl + "order/tempoOrder", obj);
    return (dFromF.data);
}

const getOrderSmallOrder = async (orderNum) => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "order/smallOrder/",{ params: { orderNum } });
    return (dFromF.data);
}

const getDuplictedOrder = async (id, token) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "order/getDuplictedOrder/" + id,  { params: { token } });
    return (dFromF.data);
}


const getCounter = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "order/counter", { CounterName: "OrdersCounter" });
    return (dFromF.data);
}



const updateStatus = async (obj) => {

    let dFromF = await axios.put(ConnUrls.ApiUrl + "order/usrupstat", obj);
    return (dFromF.data);
}





export default {
    // updateOrderPayParms,
    getDuplictedOrder,
    orderMyFood,
    getOrderSmallOrder,
    getCounter,
    updateStatus,
    tempoOrder
};



